<template>
  <LoadingIndicator v-if="loadingData" />
  <div v-else class="Pantalla-Inicio">
    <table class="Tabla">
      <tr>
        <td class="Titulo-Tabla" colspan="7">ENTRADAS</td>
      </tr>
      <tr class="Heading-Columna">
        <td></td>
        <td class="Negro">TINSA</td>
        <td class="Negro">TINSA CEE</td>
        <td class="Negro" v-if="showUve">UVE</td>
        <td class="Negro">INFORMES</td>
        <td class="Negro">OTROS</td>
        <td class="Negro">TOTAL</td>
      </tr>
      <tr class="Row-Destacada">
        <td class="Negro Heading-Row">HOY</td>
        <td class="Negro Destacado">{{this.datos.tinsa.entradas.hoy}}</td>
        <td class="Negro Destacado">{{this.datos.tinsa_cee.entradas.hoy}}</td>
        <td class="Negro Destacado" v-if="showUve">{{this.datos.uve.entradas.hoy}}</td>
        <td class="Negro Destacado">{{this.datos.informes.entradas.hoy}}</td>
        <td class="Negro Destacado">{{this.datos.otros.entradas.hoy}}</td>
        <td
          class="Negro Destacado"
        >{{this.showUve ? this.datos.total.entradas.hoy : restar(this.datos.total.entradas.hoy,this.datos.total.entradas.hoy)}}</td>
      </tr>
      <tr>
        <td class="Heading-Row">Día Anterior</td>
        <td>{{this.datos.tinsa.entradas.ayer}}</td>
        <td>{{this.datos.tinsa_cee.entradas.ayer}}</td>
        <td v-if="showUve">{{this.datos.uve.entradas.ayer}}</td>
        <td>{{this.datos.informes.entradas.ayer}}</td>
        <td>{{this.datos.otros.entradas.ayer}}</td>
        <td>{{this.showUve ? this.datos.total.entradas.ayer : restar(this.datos.total.entradas.ayer, this.datos.uve.entradas.ayer)}}</td>
      </tr>
      <tr class="Row-Destacada">
        <td class="Negro Heading-Row">MES ACTUAL</td>
        <td>{{this.datos.tinsa.entradas.mes}}</td>
        <td class="Negro Destacado">{{this.datos.tinsa_cee.entradas.mes}}</td>
        <td class="Negro Destacado" v-if="showUve">{{this.datos.uve.entradas.mes}}</td>
        <td class="Negro Destacado">{{this.datos.informes.entradas.mes}}</td>
        <td class="Negro Destacado">{{this.datos.otros.entradas.mes}}</td>
        <td
          class="Negro Destacado"
        >{{this.showUve ? this.datos.total.entradas.mes : restar(this.datos.total.entradas.mes, this.datos.uve.entradas.mes)}}</td>
      </tr>
      <tr>
        <td class="Heading-Row">Mes Anterior</td>
        <td>{{this.datos.tinsa.entradas.mes_anterior}}</td>
        <td>{{this.datos.tinsa_cee.entradas.mes_anterior}}</td>
        <td v-if="showUve">{{this.datos.uve.entradas.mes_anterior}}</td>
        <td>{{this.datos.informes.entradas.mes_anterior}}</td>
        <td>{{this.datos.otros.entradas.mes_anterior}}</td>
        <td>{{this.showUve ? this.datos.total.entradas.mes_anterior : restar(this.datos.total.entradas.mes_anterior,this.datos.uve.entradas.mes_anterior)}}</td>
      </tr>
    </table>
    <table style="margin:1% 0;" class="Tabla">
      <tr>
        <td class="Titulo-Tabla" colspan="7">ENVIADAS</td>
      </tr>
      <tr class="Heading-Columna">
        <td></td>
        <td class="Negro">TINSA</td>
        <td class="Negro">TINSA CEE</td>
        <td class="Negro" v-if="showUve">UVE</td>
        <td class="Negro">INFORMES</td>
        <td class="Negro">OTROS</td>
        <td class="Negro">TOTAL</td>
      </tr>
      <tr class="Row-Destacada">
        <td class="Negro Heading-Row">HOY</td>
        <td class="Negro Destacado">{{this.datos.tinsa.enviadas.hoy}}</td>
        <td class="Negro Destacado">{{this.datos.tinsa_cee.enviadas.hoy}}</td>
        <td class="Negro Destacado" v-if="showUve">{{this.datos.uve.enviadas.hoy}}</td>
        <td class="Negro Destacado">{{this.datos.informes.enviadas.hoy}}</td>
        <td class="Negro Destacado">{{this.datos.otros.enviadas.hoy}}</td>
        <td
          class="Negro Destacado"
        >{{this.showUve ? this.datos.total.enviadas.hoy : restar(this.datos.total.enviadas.hoy,this.datos.uve.enviadas.hoy )}}</td>
      </tr>
      <tr>
        <td class="Heading-Row">Día Anterior</td>
        <td>{{this.datos.tinsa.enviadas.ayer}}</td>
        <td>{{this.datos.tinsa_cee.enviadas.ayer}}</td>
        <td v-if="showUve">{{this.datos.uve.enviadas.ayer}}</td>
        <td>{{this.datos.informes.enviadas.ayer}}</td>
        <td>{{this.datos.otros.enviadas.ayer}}</td>
        <td>{{this.showUve ? this.datos.total.enviadas.ayer : restar(this.datos.total.enviadas.ayer, this.datos.uve.enviadas.ayer)}}</td>
      </tr>
      <tr class="Row-Destacada">
        <td class="Negro Heading-Row">MES ACTUAL</td>
        <td class="Negro Destacado">{{this.datos.tinsa.enviadas.mes}}</td>
        <td class="Negro Destacado">{{this.datos.tinsa_cee.enviadas.mes}}</td>
        <td class="Negro Destacado" v-if="showUve">{{this.datos.uve.enviadas.mes}}</td>
        <td class="Negro Destacado">{{this.datos.informes.enviadas.mes}}</td>
        <td class="Negro Destacado">{{this.datos.otros.enviadas.mes}}</td>
        <td
          class="Negro Destacado"
        >{{this.showUve ? this.datos.total.enviadas.mes : restar(this.datos.total.enviadas.mes, this.datos.uve.enviadas.mes)}}</td>
      </tr>
      <tr>
        <td class="Heading-Row">Mes Anterior</td>
        <td>{{this.datos.tinsa.enviadas.mes_anterior}}</td>
        <td>{{this.datos.tinsa_cee.enviadas.mes_anterior}}</td>
        <td v-if="showUve">{{this.datos.uve.enviadas.mes_anterior}}</td>
        <td>{{this.datos.informes.enviadas.mes_anterior}}</td>
        <td>{{this.datos.otros.enviadas.mes_anterior}}</td>
        <td>{{this.showUve ? this.datos.total.enviadas.mes_anterior : restar(this.datos.total.enviadas.mes_anterior, this.datos.uve.enviadas.mes_anterior)}}</td>
      </tr>
    </table>
    <table class="Tabla">
      <tr>
        <td class="Titulo-Tabla" colspan="7">OTROS ESTADOS</td>
      </tr>
      <tr class="Heading-Columna">
        <td></td>
        <td class="Negro">TINSA</td>
        <td class="Negro">TINSA CEE</td>
        <td class="Negro" v-if="showUve">UVE</td>
        <td class="Negro">INFORMES</td>
        <td class="Negro">OTROS</td>
        <td class="Negro">TOTAL</td>
      </tr>
      <tr>
        <td class="Heading-Row">Incidencias</td>
        <td>{{this.datos.tinsa.otros.incidencias}}</td>
        <td>{{this.datos.tinsa_cee.otros.incidencias}}</td>
        <td v-if="showUve">{{this.datos.uve.otros.incidencias}}</td>
        <td>{{this.datos.informes.otros.incidencias}}</td>
        <td>{{this.datos.otros.otros.incidencias}}</td>
        <td>{{this.showUve ? this.datos.total.otros.incidencias : restar(this.datos.total.otros.incidencias, this.datos.uve.otros.incidencias)}}</td>
      </tr>
      <tr>
        <td class="Heading-Row">Pendientes de Visita</td>
        <td>{{this.datos.tinsa.otros.pendientes_visita}}</td>
        <td>{{this.datos.tinsa_cee.otros.pendientes_visita}}</td>
        <td v-if="showUve">{{this.datos.uve.otros.pendientes_visita}}</td>
        <td>{{this.datos.informes.otros.pendientes_visita}}</td>
        <td>{{this.datos.otros.otros.pendientes_visita}}</td>
        <td>{{this.showUve ? this.datos.total.otros.pendientes_visita : restar(this.datos.total.otros.pendientes_visita, this.datos.uve.otros.pendientes_visita)}}</td>
      </tr>
      <tr>
        <td class="Heading-Row">Pendientes de Salida</td>
        <td>{{this.datos.tinsa.otros.pendientes_salida}}</td>
        <td>{{this.datos.tinsa_cee.otros.pendientes_salida}}</td>
        <td v-if="showUve">{{this.datos.uve.otros.pendientes_salida}}</td>
        <td>{{this.datos.informes.otros.pendientes_salida}}</td>
        <td>{{this.datos.otros.otros.pendientes_salida}}</td>
        <td>{{this.showUve ? this.datos.total.otros.pendientes_salida : restar(this.datos.total.otros.pendientes_salida, this.datos.uve.otros.pendientes_salida)}}</td>
      </tr>
      <tr class="Row-Destacada">
        <td class="Heading-Row Negro">TOTAL OTROS ESTADOS</td>
        <td class="Negro Destacado">{{this.datos.tinsa.otros.total}}</td>
        <td class="Negro Destacado">{{this.datos.tinsa_cee.otros.total}}</td>
        <td class="Negro Destacado" v-if="showUve">{{this.datos.uve.otros.total}}</td>
        <td class="Negro Destacado">{{this.datos.informes.otros.total}}</td>
        <td class="Negro Destacado">{{this.datos.otros.otros.total}}</td>
        <td
          class="Negro Destacado"
        >{{this.showUve ? this.datos.total.otros.total : restar(this.datos.total.otros.total, this.datos.uve.otros.total)}}</td>
      </tr>
    </table>
    <table style="margin:1% 0;" class="Tabla">
      <tr>
        <td class="Titulo-Tabla" colspan="7">Encargos paralizados</td>
      </tr>
      <tr class="Heading-Columna">
        <td></td>
        <td class="Negro">TINSA</td>
        <td class="Negro">TINSA CEE</td>
        <td class="Negro" v-if="showUve">UVE</td>
        <td class="Negro">INFORMES</td>
        <td class="Negro">OTROS</td>
        <td class="Negro">TOTAL</td>
      </tr>
      <tr>
        <td class="Heading-Row">Total</td>
        <td>{{this.datos.paralizados.tinsa}}</td>
        <td>{{this.datos.paralizados.tinsa_cee}}</td>
        <td v-if="showUve">{{this.datos.paralizados.uve}}</td>
        <td>{{this.datos.paralizados.informes}}</td>
        <td>{{this.datos.paralizados.otros}}</td>
        <td>{{ this.showUve ? this.datos.paralizados.total : restar(this.datos.paralizados.total,this.datos.paralizados.uve)}}</td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { panelAPI } from '@/api';
import LoadingIndicator from '@/components/LoadingIndicator';

export default {
  name: 'pantallaInicio',

  data() {
    return {
      datos: {},
      loadingData: false,
      tiempo: '',
    };
  },
  created() {
    console.log(process.env.VUE_APP_SHOWUVE);
    this.cargarDatosPanel();
    this.tiempo = setInterval(this.cargarDatosPanel, 1 * 60 * 1000);
  },
  methods: {
    async cargarDatosPanel() {
      console.log('Cargando datos del panel');
      this.loadingData = true;
      this.datos = await panelAPI.getAll();
      this.loadingData = false;
      // this.recargarEnCincoMinutos();
    },
    restar(numero, resta) {
      return numero - resta;
    },
  },
  computed: {
    showUve() {
      if (process.env.VUE_APP_SHOWUVE === 'SI') {
        return true;
      }
      return false;
    },
  },
  components: {
    LoadingIndicator,
  },
};
</script>
<style scoped>
* {
  --Azul: #338def;
  --Azul-Claro: #d3e5fa;
  font-family: "Open Sans", sans-serif;
  text-align: center;
}

table {
  border-spacing: 0px;
}

td {
  padding: 1vh 0;
  color: #666666;
  font-size: 13px;
}

.Negro {
  color: black;
}

.Pantalla-Inicio {
  /*     width:100vw;
 */
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  flex-direction: column;
}

.Tabla {
  width: 95%;
  background-color: white;
}

.Titulo-Tabla {
  background-color: var(--Azul);
  color: white;
  border-radius: 8px 8px 0 0;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
  padding: 10px 0;
  font-size: 15px;
}

.Heading-Columna {
  font-weight: bold;
  color: black;
  text-align: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-variant: small-caps;
  font-size: 12px;
}

.Heading-Row {
  text-align: left;
  padding-left: 30px;
  width: 15%;
  font-size: 13px;
}

.Row-Destacada {
  background: var(--Azul-Claro);
  font-weight: bold;
  font-size: 14px;
}

.Destacado {
  font-size: 18px;
}
</style>
